import ScheduleComponent from '@/modules/ScheduleComponent';
import { Field } from 'formik';
import { getDateLocale } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { FormikDatePicker } from 'globalcomponents/UI/Form/Base';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Select = lazy(() => import(`globalcomponents/UI/Select/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);

const RenderComponent = ({
  values,
  handleEdit,
  errors,
  isNotValid,
  validateForm,
  submitAction,
  customProps: { i18n, vehicles, drivers },
}) => {
  const [onSubmitClick, setOnSubmitClick] = useState(false);
  return (
    <>
      {checkServiceProvider('malFunctionReportRenderComponent_message', window.$environment.SERVICE_PROVIDER, false) &&
        onSubmitClick &&
        !values?.driverIds?.length &&
        !values?.vehicleIds?.length && <Message type="error" message={i18n.t('common.driverNameOrVehicleNameRequired')} />}
      <FormStyle.default.FieldsWrapper className="fieldWrapper">
        <Label htmlFor="driverIds">{i18n.t('common.driver')}</Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="driverIds"
            onChange={(event) => {
              handleEdit(event, { field: 'driverIds' });
            }}
            as={Select}
            placeholder={i18n.t('common.pleaseSelect')}
            value={values.driverIds}
            suggestions={drivers.data}
            isClearable
            isMulti
            allowSelectAll
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.FieldsWrapper className="fieldWrapper">
        <Label htmlFor="vehicleIds">{i18n.t('common.vehicle')}</Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="vehicleIds"
            onChange={(event) => {
              handleEdit(event, { field: 'vehicleIds' });
            }}
            as={Select}
            placeholder={i18n.t('common.pleaseSelect')}
            value={values.vehicleIds}
            suggestions={vehicles?.vehicleList.map((items) => ({
              label: items.unit_id,
              value: items.id,
            }))}
            isClearable
            isMulti
            allowSelectAll
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      {values.recurrenceType == 'RECURRING' ? null : (
        <>
          <FormStyle.default.FieldsWrapper className="fieldWrapper">
            <Label htmlFor="startDate">{i18n.t('common.dateFrom')}</Label>
            <FormStyle.default.TextWrapper>
              <Field
                name="startDate"
                onChange={(event) => {
                  handleEdit(event, { field: 'startDate', type: 'date' });
                }}
                as={FormikDatePicker}
                locale={getDateLocale()}
                placeholderText={i18n.t('common.datePicker')}
                value={values.startDate}
                showPopperArrow={false}
                showTimeSelect={false}
                showDisabledMonthNavigation
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                maxDate={values.endDate ? new Date(values.endDate) : new Date()}
              />
              {errors['startDate'] && !isNotValid && <Message type="error" message={errors['startDate']} />}
            </FormStyle.default.TextWrapper>
          </FormStyle.default.FieldsWrapper>
          <FormStyle.default.FieldsWrapper className="fieldWrapper">
            <Label htmlFor="endDate">{i18n.t('common.dateTo')}</Label>
            <FormStyle.default.TextWrapper>
              <Field
                name="endDate"
                onChange={(event) => {
                  handleEdit(event, { field: 'endDate', type: 'date' });
                }}
                as={FormikDatePicker}
                locale={getDateLocale()}
                placeholderText={i18n.t('common.datePicker')}
                value={values.endDate}
                showPopperArrow={false}
                showTimeSelect={false}
                maxDate={new Date()}
                showDisabledMonthNavigation
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={values.startDate ? new Date(values.startDate) : new Date('01/01/2000')}
              />
              {errors['endDate'] && !isNotValid && <Message type="error" message={errors['endDate']} />}
            </FormStyle.default.TextWrapper>
          </FormStyle.default.FieldsWrapper>
        </>
      )}

      <ScheduleComponent
        values={values}
        handleEdit={handleEdit}
        validateForm={validateForm}
        submitAction={(data) => {
          if (!onSubmitClick) setOnSubmitClick(true);
          submitAction(data);
        }}
        customProps={{ i18n }}
      />
    </>
  );
};

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};

export default RenderComponent;
